<template>
      <div
        class="modal right fade trader-info"
        id="trader-info"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"       
      >
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title mr-auto p-2" >{{customerData.customerFirstName ? customerData.customerFirstName[0] : ""}}. {{customerData.customerLastName}} contacts</h5> 
              <div class="float-right">
                <button type="button" @click="openAddForm()" class="btn btn-sm btn-success">ADD</button>
                <button type="button" class="close"  @click="$emit('close')">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
            <div class="modal-body">
                <div v-if="isAddOrEdit">
                    <div class="form-row">
                    <div class="form-group col-md-6 required">
                        <label for="inputEmail4">First Name</label>
                        <input  type="text" class="form-control" id="inputEmail4" placeholder="First name"  v-model="contactData.firstName" >
                    </div>
                    <div class="form-group col-md-6">
                        <label for="inputLast">Middle Name</label>
                        <input type="text" class="form-control" id="inputLast" placeholder="Middle name"  v-model="contactData.middleName" >
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6 required">
                        <label for="inputLast">Last Name</label>
                        <input type="text" class="form-control" id="inputLast" placeholder="Last name"  v-model="contactData.lastName" > 
                    </div>    
                    <div class="form-group col-md-6 required">
                        <label for="inputLocation">Email</label>
                        <input type="email" class="form-control" placeholder="Email"  v-model="contactData.email">
                    </div>
                </div>
                <div class="form-row">
                     <div class="form-group col-md-6 required">
                        <label for="inputEmail4">Title</label>
                        <select class="form-control" v-model="contactData.title" >
                        <option
                            v-for="titile in ['SIR', 'MR', 'MS', 'MA_AM', 'MRS']"
                            :key="titile"
                            v-bind:value="titile"
                        >{{capitalizeFirstLetter(titile)}}</option>
                    </select>
                    </div>
                </div> 
                </div>
                 <p v-if="errors.length">
                    <ul>
                    <li class="alert alert-danger" role="alert" v-for="error in errors" v-bind:key="error">{{ error }}</li>
                    </ul>
                </p>
                <div  v-if="isAddOrEdit" class="modal-footer">
                    <button class="btn btn-light"  @click="closeAddForm();" type="button">Cancel</button>
                    <button v-if="!isEdit" class="btn btn-primary" type="button" @click="addContact()">ADD</button>
                    <button v-if="isEdit" class="btn btn-primary" type="button" @click="updateContact()">UPDATE</button>
                    </div>
                <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                <table class="table align-items-center table-flush table-hover bidtbl">
                    <thead class="thead-light psticky">
                    <tr>
                        <th scope="col" class="text-center">TITLE</th>
                        <th scope="col" class="text-center">FIRST NAME</th>
                        <th scope="col" class="text-center">MIDDLE NAME</th>
                        <th scope="col" class="text-center">LAST NAME</th>
                        <th scope="col" class="text-center">EMAIL</th>
                        <th scope="col" class="text-center">ACTION</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="customers.length == 0 && !loading">
                        <td><p class="nodata">No data available</p>
                        </td>
                    </tr>
                    <tr v-for="customer in customers" :key="customer.id">
                        <td><span>{{capitalizeFirstLetter(customer.title)}}</span></td>
                        <td><span>{{customer.firstName}}</span></td>
                        <td><span>{{customer.middleName}}</span></td>
                        <td><span>{{customer.lastName}}</span></td>
                        <td><span>{{customer.email}}</span></td>
                        <td>
                           <div class="d-inline-flex"> 
                            <div class="dropdown">
                                <button class="btn ibtn blk dropdown-toggle" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i class="fas fa-ellipsis-v"></i>
                                </button>
                                <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
                                    <button @click="editContact(customer)" class="dropdown-item" type="button">Edit</button>
                                    <button @click="deleteContact(customer)" class="dropdown-item del" type="button">Delete</button>
                                </div>
                            </div>
                           </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
          </div>
        </div>
      </div>
</template>

<script>
    import authService from "@/authService";
    import config from "@/config";
    export default {
        name: 'customerEmails',
        components :{
            
        },
        props: ['customerData'],
        data() {
            return {
                loading : false,
                contactData : {title:"SIR"},
                customers : [],
                isAddOrEdit : false,
                isEdit : false,
                customerEmail : null,
                errors : [],   
                selectedEmail : null       
            };
        },
        methods: {  
            checkForm(){
                this.errors = [];
                if (!this.contactData.firstName) {
                    this.errors.push("First name is required.");
                    return false;
                }
                if (!this.contactData.lastName) {
                    this.errors.push("Last name is required.");
                    return false;
                }
                if (!this.contactData.title) {
                    this.errors.push("Title is required.");
                    return false;
                }
                if (!this.contactData.email) {
                    this.errors.push("Email is required.");
                    return false;
                }
                if(!this.validateEmail(this.contactData.email)){
                    this.errors.push("You have entered an invalid email address!");
                    return false;
                }
                // if(mode === 'ADD' && this.checkEmailAlreadyExist(this.customers,this.contactData.email)){
                //     this.errors.push("This email address already exists.");
                //     return false;
                // }
                // let customerEmails = this.customers.filter((item) => item.email !== this.contactData.email);
                // if(mode === 'UPDATE' && this.checkEmailAlreadyExist(customerEmails,this.contactData.email)){
                //     this.errors.push("This email address already exists.");
                //     return false;
                // }
                return true
            },
            checkEmailAlreadyExist(arr,email){
                return arr.some(function(arrVal) {
                    return email === arrVal.email;
                });
            },
            capitalizeFirstLetter(string) {
                if(!string) return 'N/A';
                string = string.toLowerCase().replace('_' , "'");
                //console.log(string)
                if(string == 'mr' || string == 'ms' || string == 'mrs'){
                    string = string+ '.'
                }
                return string.charAt(0).toUpperCase() + string.slice(1);
            },
            addContact(){
              let isValid = this.checkForm();
              if (isValid) {
              const auth = {
                    headers: { 'org-token' : authService.getOrgToken()  }
                };
              var addData = {};
                addData.customerId = this.customerData.id;
                addData.firstName = this.contactData.firstName;
                addData.middleName = this.contactData.middleName;
                addData.lastName = this.contactData.lastName;
                addData.title = this.contactData.title;
                addData.email =  this.contactData.email;
                this.loading = true;
              this.$http
                .post(
                config.baseUrlBidSide +
                    "/customer/email",
                    addData,
                    auth
                )
                .then(() => {
                    this.loading = false;
                    this.$alert("Contact Added","","success")
                    this.contactData = {};
                    this.getCustomers();
                    this.isAddOrEdit = false;
                })
                .catch(() => {
                    this.loading = false;              
                });
              }
            },
            updateContact(){
                let isValid = this.checkForm();
                if (isValid) {
                this.loading = true;
                    var updateData = {...this.contactData};
                    const auth = {
                        headers: { 'org-token' : authService.getOrgToken()  }
                    };
                    this.$http
                    .put(config.baseUrlBidSide + "/customer/email", updateData, auth)
                    .then(() => {
                        this.loading = false;
                        this.$alert("Contact Updated","","success")
                        this.closeAddForm();
                        this.getCustomers();
                        this.contactData = {};             
                    })
                    .catch(() => {
                        this.loading = false;              
                    });
                }

            },
            deleteContact(customer){
                var message = "Are you sure you want to delete this contact?";
                this.$confirm(message,"Delete Contact","",{confirmButtonText:"Delete",cancelButtonText : "No"}).then(() => {
                    this.loading = true;
                    // const auth = {
                    //     headers: { 'org-token' : authService.getOrgToken() }
                    // };
                    // var deleteData = {};
                    // deleteData.id = customer.id;
                    // deleteData.customerId =  customer.customerId;
                    this.$http
                    .delete(
                        config.baseUrlBidSide +"/customer/email",{ data: { id: customer.id,customerId:customer.customerId }, headers: { 'org-token' : authService.getOrgToken() } }
                    )
                    .then(() => {
                        this.getCustomers();
                        this.$alert("Contact Deleted","","success")
                        this.loading = false;
                    })
                });
            },
            validateEmail(email) {
                const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(String(email).toLowerCase());
            },
            openAddForm(){
                this.isAddOrEdit = true;
                this.isEdit = false;
                this.contactData = {title:"SIR"};
                this.errors = [];
            },
            closeAddForm(){
                this.isAddOrEdit = false;
                this.isEdit = false;
                this.contactData = {title:"SIR"};
                this.errors = [];
            },
            editContact(customer){
                this.contactData = {...customer};
                this.isAddOrEdit = true;
                this.isEdit = true;
            }, 
            getCustomers(){
                this.loading = true;
                const auth = {
                    headers: { 'org-token' : authService.getOrgToken() }
                };
                this.$http
                .get(
                config.baseUrlBidSide +
                    "/customer/email/list?customerId="+this.customerData.id,
                    auth
                )
                .then(result => {
                    this.customers = result.data;
                    this.loading = false;
                })
            }

        },
        mounted(){
          this.getCustomers();
        }
    };
    </script>